import { render, staticRenderFns } from "./LoanableForm.vue?vue&type=template&id=4e553260&scoped=true&"
import script from "./LoanableForm.vue?vue&type=script&lang=js&"
export * from "./LoanableForm.vue?vue&type=script&lang=js&"
import style0 from "./LoanableForm.vue?vue&type=style&index=0&id=4e553260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e553260",
  null
  
)

export default component.exports